import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, RouteReuseStrategy } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomReuseStrategy } from './reuse';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import {
  MatCheckboxModule,
  MAT_CHECKBOX_CLICK_ACTION
} from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MatDialogModule,
  MAT_DIALOG_DEFAULT_OPTIONS
} from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './Dialogs/confirm-dialog/confirm-dialog.component';
import { SettingsDialogComponent } from './Dialogs/settings/settings-dialog.component';
import { RetracementSettingsDialogComponent } from '../components/retracement-settings/retracement-settings.component';
import { RetracementTabsComponent } from './Dialogs/retracementTabs/retracementTabs.component';
import { DialogLoginComponent } from './Dialogs/dialog.login/dialog.login.component';
import { ViewsDialogComponent } from './Dialogs/views/views.component';
import { ViewsSelectorComponent } from './Dialogs/viewsSelector/viewsSelector.component';
import { ReloadDialogComponent } from './Dialogs/reload/reload.component';
import { RetracementMenuComponent } from 'src/components/retracement-menu/retracement-menu.component';
import { ViewsEditDialogComponent } from './Dialogs/views-edit/views-edit.component';
import { PriceLineSettingsDialogComponent } from './Dialogs/priceLIneSettings/priceLIneSettings.component';
import { SignalsVisualizationComponent } from 'src/components/signals-visualization/signals-visualization.component';
import { RytmicActionComponent } from 'src/components/rytmicaction/rytmicaction.component';
import { RytmicColorRampComponent } from './Dialogs/RytmicColorRamp/RytmicColorRamp.component';
import { ToastrModule } from 'ngx-toastr';
import { EventsComponent } from './Dialogs/Events/Events.component';
import { SpotTickerComponent } from 'src/components/spot-ticker/spot-ticker.component';
@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    RytmicActionComponent,
    RytmicColorRampComponent,
    HomeComponent,
    ConfirmDialogComponent,
    SettingsDialogComponent,
    ViewsDialogComponent,
    ViewsEditDialogComponent,
    RetracementSettingsDialogComponent,
    RetracementTabsComponent,
    EventsComponent,
    PriceLineSettingsDialogComponent,
    ViewsSelectorComponent,
    DialogLoginComponent,
    ReloadDialogComponent,
    RetracementMenuComponent,
    SignalsVisualizationComponent,
    SpotTickerComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
     ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
    ]),
    CommonModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    ToastrModule.forRoot()
  ],
  entryComponents:[
    ConfirmDialogComponent,
    RytmicColorRampComponent,
    SettingsDialogComponent,
    ViewsDialogComponent,
    ViewsEditDialogComponent,
    RetracementSettingsDialogComponent,
    RetracementTabsComponent,
    EventsComponent,
    PriceLineSettingsDialogComponent,
    DialogLoginComponent,
    ReloadDialogComponent
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
